var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5C20.2761 12.5 20.5 12.2761 20.5 12C20.5 11.7239 20.2761 11.5 20 11.5V12.5ZM4 12L3.64645 11.6464L3.29289 12L3.64645 12.3536L4 12ZM9.35355 7.35355C9.54882 7.15829 9.54882 6.84171 9.35355 6.64645C9.15829 6.45118 8.84171 6.45118 8.64645 6.64645L9.35355 7.35355ZM8.14645 16.8536C8.34171 17.0488 8.65829 17.0488 8.85355 16.8536C9.04882 16.6583 9.04882 16.3417 8.85355 16.1464L8.14645 16.8536ZM20 11.5H4V12.5H20V11.5ZM4.35355 12.3536L9.35355 7.35355L8.64645 6.64645L3.64645 11.6464L4.35355 12.3536ZM3.64645 12.3536L8.14645 16.8536L8.85355 16.1464L4.35355 11.6464L3.64645 12.3536Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBig);
export default __webpack_public_path__ + "static/media/arrow-left-big.f9d00f2f.svg";
export { ForwardRef as ReactComponent };